import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Gemstone_Filters } from "../../../store/actions/CommanAction";
import DataTable from "react-data-table-component";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import Select from "react-select";
import swal from "sweetalert";

const GemstoneFilter = () => {
  const dispatch = useDispatch();
  const GemstoneFilter = useSelector(
    (state) => state.feedBackReducer.GemstoneFilter
  );

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [PaymentStatus, setPaymentStatus] = useState("pending");
  const [loading, setloading] = useState(false);
  const [dropdownpaymentdata, setDropdonpaymentdata] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedAstro, setSelectedAstro] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);
    dispatch(
      Gemstone_Filters(
        formattedToday,
        formattedToday,
        PaymentStatus,
        isActive,
        setloading
      )
    );
  }, [dispatch]);

  const handleSearch = (isActive) => {
    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);

    const data = {
      FromDate: formattedStartDate,
      Todate: formattedEndDate,
      PaymentStatus: PaymentStatus,
    };

    dispatch(
      Gemstone_Filters(
        data.FromDate,
        data.Todate,
        data.PaymentStatus,
        isActive,
        setloading
      )
    );
  };
  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setStartTime("");
    setEndTime("");
  };
  const dropdowndata = async () => {
    const res = await AddUpdate("Expense/GetGropDwonData_PaymentStatus");

    if(res?.data?.data){
      
    const data = JSON?.parse(res?.data?.data);

    const finaldata = data?.Table;

    setDropdonpaymentdata(finaldata);
    }
    
  };
  useEffect(() => {
    dropdowndata();
  }, []);

  const UpdateSlider = async () => {
    let error = false;
    let errormsg = "";

    if (!selectedAstro) {
      error = true;
      errormsg = "Please select Payment Status";
    }
    if (!error) {
      const postdata = {
        PaymentStatus: selectedAstro.label,
        GemstoneOrderID: id,
      };
      const res = await AddUpdate(
        "GemstoneOrder/Update_PaymentStatus",
        postdata
      );

      if (res.status == 200) {
        swal("Good job", "successfully update");
        setEditModal(false);
        setSelectedAstro("");
        setId("");
        dispatch(
          Gemstone_Filters(
            startTime,
            endTime,
            PaymentStatus,
            isActive,
            setloading
          )
        );
      } else {
        const message = res.data.Message;
        swal(`${message}`);
      }
    }
    else {
          swal("Oops", errormsg, "error");
        }
  };

  useEffect(() => {
    if (dropdownpaymentdata && Array.isArray(dropdownpaymentdata)) {
      const filtered = dropdownpaymentdata.map(({ StatusName, PaymentId }) => ({
        label: StatusName,
        value: PaymentId,
      }));
      setFilteredData(filtered);
    }
  }, [dropdownpaymentdata]);

  const handleToggleStatusClick = (row) => {
    setId(row.GemstoneOrderID);
    setEditModal(true);
  };

  const columns = [
    {
      name: "GemstoneName",
      selector: (row) => row.GemstoneName,
      sortable: true,
    },
    
    {
      name: "User Name",
      selector: (row) => row.UserName,
      sortable: true,
    },
    {
      name: "Mobile Number",
      selector: (row) => row.MobileNo,
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => row.Address,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.Amt,
      sortable: true,
    },
    {
      name: "PaymentStatus",
      selector: (row) => row.paymentstatus,
      sortable: true,
    },
    {
      name: "Order Status",
      selector: (row) => row.OrderStatus,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{
            position: "absolute",
            top: "7px",
            right: 50,
          }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div
          style={{
            position: "absolute",
            top: 4,
            right: 50,
          }}
        >
          <Dropdown>
            <Dropdown.Toggle
              as="div"
              variant=""
              className="btn-link i-false"
              style={{
                backgroundColor: "white",
                border: "none",
                boxShadow: "none",
                padding: "5px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu align="end" className="dropdown-menu-right">
              <Dropdown.Item
                onClick={() => {
                  handleToggleStatusClick(row);
                }}
                style={{ color: "#f7931e", fontWeight: "bold" }}
              >
                Edit
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="form-group main_card">
        <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Gemstones Booking</h2>
        <div className="row mt-3">
          <div className="col-lg-3">
            <label>Start Time</label>
            <input
              type="date"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>

          <div className="col-lg-3">
            <label>End Time</label>
            <input
              type="date"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>

        <div className="d-flex align-items-center mt-3">
          <label
            style={{
              marginRight: "10px",
              marginTop: "10px",
              color: "black",
              fontSize: "15px",
              fontStyle: "bold",
            }}
          >
            Payment Status:
          </label>
          <div className="d-flex">
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginRight: "10px",
                color: "black",
                marginTop: "15px",
              }}
            >
              <input
                type="radio"
                name="PaymentStatus"
                value="complete"
                checked={PaymentStatus === "completed"}
                onChange={() => setPaymentStatus("completed")}
              />
              Complete
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginRight: "10px",
                color: "black",
                marginTop: "15px",
              }}
            >
              <input
                type="radio"
                name="PaymentStatus"
                value="pending"
                checked={PaymentStatus === "pending"}
                onChange={() => setPaymentStatus("pending")}
              />
              Pending
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginRight: "10px",
                color: "black",
                marginTop: "15px",
              }}
            >
              <input
                type="radio"
                name="PaymentStatus"
                value="all"
                checked={PaymentStatus === null}
                onChange={() => setPaymentStatus(null)}
              />
              All
            </label>

            <button
              className="btn btn-primary mt-3"
              onClick={() => handleSearch(isActive)}
            >
              Search
            </button>
            <button
              className="btn btn-secondary  ms-2 mt-3"
              onClick={handleReset}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      <div className="card-action coin-tabs mb-2 main_card">
        <Nav variant="tabs">
          <Nav.Item as="li" className="nav-item">
            <Nav.Link
              className={`nav-link ${isActive ? "active" : ""}`}
              onClick={() => {
                setIsActive(true);
                handleSearch(true);
              }}
            >
              Active
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li" className="nav-item">
            <Nav.Link
              className={`nav-link ${!isActive ? "active" : ""}`}
              onClick={() => {
                setIsActive(false);
                handleSearch(false);
              }}
            >
              Inactive
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Modal
          className="modal fade "
          show={editModal}
          onHide={setEditModal}
          backdrop="static"
        >
          <div className="" role="document">
            <div className="">
              <form>
                <div className="modal-header">
                  <h4 className="modal-title fs-20">Edit Payment Status</h4>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setEditModal(false)}
                    data-dismiss="modal"
                  ></button>
                </div>
                <div className="modal-body p-3">
                  <i
                    className="flaticon-cancel-12 close"
                    data-dismiss="modal"
                  ></i>
                  <div className="add-contact-box">
                    <div>
                      <label htmlFor="">Select Status</label>
                      <span className="text-danger star-error">*</span>
                      <Select
                        options={filteredData}
                        value={selectedAstro}
                        onChange={(selectedOption) =>
                          setSelectedAstro(selectedOption)
                        }
                        placeholder="Select Status"
                        isSearchable
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={UpdateSlider}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setEditModal(false);
                    }}
                    className="btn btn-danger"
                  >
                    {" "}
                    <i className="flaticon-delete-1"></i> Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        <div className="col-12 mt-2 ">
          {loading ? (
            <Loader />
          ) : (
            <DataTable
              dense
              data={GemstoneFilter || []}
              columns={columns}
              selectableRowsHighlight
              pagination
              persistTableHead={true}
              customStyles={customStyles}
              noDataComponent={"There are no data to display"}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default GemstoneFilter;
